import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import "./index.scss"

export default function InnerResourceReadingCTA({ component }) {
  const { headline, description, typeOfCta, buttonLink, image } = component
  return (
    <>
      <Link to={buttonLink[0].linkUrl}>
        <div className="inner-reading-cta">
          <div className="inner-reading-cta--image">
            <GatsbyImage image={getImage(image)} />
          </div>
          <div className="inner-reading-cta--text text-white">
            <span>{typeOfCta}</span>
            <h4 className="oblique">{headline}</h4>
            <div
              className="inner-reading-cta__intro"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            <Link to={buttonLink[0].linkUrl} className="btn btn-secondary">
              {buttonLink[0].label}
            </Link>
          </div>
        </div>
      </Link>
    </>
  )
}
